import React from "react"
import { css } from "@emotion/core"

function TreeSideways({styles= ""}) {
  return (
    <svg
      aria-labelledby="sideways-tree-icon"
      role="presentation"
      viewBox="0 0 9 7"
      xmlns="http://www.w3.org/2000/svg"
      css={css`
        width: "100%";
        ${styles}
      `}
    >
      <title id="sideways-tree-icon" lang="en">
        Sideways Tree Icon
      </title>
      <g fill="none" fillRule="evenodd">
        <path
          fill="#005B00"
          d="M1.052 3.427h1.722v-2.34l6.15 2.8-6.15 2.799v-2.34H1.052z"
        />
        <path
          stroke="#005B00"
          strokeWidth=".5"
          strokeLinejoin="round"
          d="M1.052 3.427h1.722v-2.34l6.15 2.8-6.15 2.799v-2.34H1.052z"
        />
      </g>
    </svg>
  )
}

export default TreeSideways
